import React, { FC } from 'react';

import { useAppDispatch, useAppSelector } from 'js/store/hooks';
import { selectCharacter, navigateBackFromCharacters } from 'js/actionCreators/imageSearchActions';

import { CHARACTERS } from './CharacterConsts';
import './CharactersView.css';

interface CharactersViewProps {
  onBack: () => void;
}

const CharactersView: FC<CharactersViewProps> = ({ onBack }) => {
  const dispatch = useAppDispatch();
  const visualStyleFilter = useAppSelector(state => state.imageSearch.visualStyleFilter);
  const activeVisualStyle = Object.values(visualStyleFilter).flat()[0] as string | undefined;
  const filteredCharacters = activeVisualStyle
    ? CHARACTERS.filter(c => c.visualStyle === activeVisualStyle)
    : CHARACTERS;

  return (
    <div className="CharactersView">
      <button
        className="CharactersView__back"
        onClick={activeVisualStyle ? () => dispatch(navigateBackFromCharacters()) : onBack}
      >
        ‹ Back to library
      </button>
      <div className="CharactersView__titleRow">
        <h2 className="CharactersView__title">Characters · {filteredCharacters.length}</h2>
        <span className="CharactersView__hint">Select a character to see poses</span>
      </div>
      <div className="CharactersView__grid">
        {filteredCharacters.map(({ id, name, SvgComponent, visualStyle }) => (
          <button
            key={id}
            aria-label={`Select ${name}`}
            className="CharactersView__card"
            onClick={() => dispatch(selectCharacter(name, visualStyle))}
          >
            <div className="CharactersView__avatar">
              <SvgComponent className="CharactersView__avatarSvg" />
            </div>
            <span className="CharactersView__name">{name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CharactersView;
